import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const AdminPrivateRoute = () => {
  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  if(localStorage.getItem("role")) {
    if(localStorage.getItem("role") === "4419ab4b-bae0-4426-a4d0-1d2e5f3b60d1") return <Outlet />
    }
    localStorage.clear();
    return <Navigate to="/login" />
};